<template>
  <page-header-wrapper>
    <div class="business-page erp-list-page baidao-list-page crm-pool-page">
      <section class="erp-search-card">
        <a-form layout="inline"><a-row :gutter="24">
          <a-col :md="6" :sm="12"><a-form-item label="经营主体"><a-input :value="subjectLabel(currentSubjectId)" disabled /></a-form-item></a-col>
          <a-col :md="6" :sm="12"><a-form-item label="入池原因"><a-select v-model="query.entryReason" allow-clear placeholder="全部原因"><a-select-option v-for="item in reasons" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></a-form-item></a-col>
          <a-col :md="6" :sm="12"><a-form-item label="所属区域"><a-tree-select
            v-model="query.regionId"
            allow-clear
            show-search
            tree-node-filter-prop="title"
            :tree-data="areaTree"
            :replace-fields="areaReplaceFields"
            placeholder="全部区域" /></a-form-item></a-col>
          <a-col v-if="activeTab === 'lead'" :md="6" :sm="12"><a-form-item label="线索等级"><a-select v-model="query.levelCode" allow-clear placeholder="全部等级"><a-select-option v-for="item in leadLevels" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></a-form-item></a-col>
          <a-col v-else :md="6" :sm="12"><a-form-item label="客户类型"><a-select v-model="query.customerKind" allow-clear placeholder="全部类型"><a-select-option v-for="item in customerKinds" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></a-form-item></a-col>
          <a-col :md="12" :sm="24"><a-form-item label="关键字"><a-input v-model.trim="query.keyword" allow-clear :placeholder="activeTab === 'lead' ? '线索编号、企业或联系人' : '客户编码或客户名称'" @pressEnter="search" /></a-form-item></a-col>
          <a-col :md="24" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="search">查询</a-button><a-button icon="redo" @click="resetQuery">重置</a-button></a-col>
        </a-row></a-form>
      </section>

      <section class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>公海池客户</h3><p>公海内资料只读且敏感字段脱敏，领取或分配后回到原业务档案继续跟进。</p></div>
          <div class="erp-toolbar-actions"><span class="erp-record-count">共 {{ total }} 条</span><a-button v-hasPermi="['erp:crm:pool:export']" icon="download" :loading="exporting" :disabled="!total" @click="exportCurrent">导出当前查询</a-button></div>
        </div>
        <a-tabs v-model="activeTab" class="pool-tabs" @change="changeTab"><a-tab-pane key="lead" tab="线索公海" /><a-tab-pane key="customer" tab="客户公海" /></a-tabs>
        <div class="pool-view-toolbar">
          <a-button icon="check" :disabled="!selectedRowKeys.length" @click="batchClaim">批量领取</a-button>
          <span v-if="selectedRowKeys.length" class="pool-selection-hint">已选 {{ selectedRowKeys.length }} 条，将逐条校验领取额度与冷却期</span>
          <span v-else class="pool-rule-hint"><a-icon type="safety-certificate" /> 当前规则：保护期 {{ poolConfig.protectionDays }} 天、{{ poolConfig.reclaimCooldownDays }} 天重领冷却、每 {{ poolConfig.claimLimitDays }} 天最多领取 {{ poolConfig.claimLimitCount }} 条</span>
        </div>
        <a-table
          row-key="id"
          bordered
          size="middle"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          :row-selection="rowSelection"
          :scroll="{ x: activeTab === 'lead' ? 1580 : 1500 }"
          :locale="{ emptyText: activeTab === 'lead' ? '暂无线索公海数据' : '暂无客户公海数据' }"
          @change="changePage">
          <template slot="objectCode" slot-scope="text, record"><a @click="openView(record)">{{ text }}</a></template>
          <template slot="regionId" slot-scope="text">{{ areaLabel(text) }}</template>
          <template slot="entryReason" slot-scope="text"><a-tag color="orange">{{ dictLabel(reasons, text) }}</a-tag></template>
          <template slot="sourceCode" slot-scope="text">{{ dictLabel(leadSources, text) }}</template>
          <template slot="levelCode" slot-scope="text">{{ activeTab === 'lead' ? dictLabel(leadLevels, text) : dictLabel(customerLevels, text) }}</template>
          <template slot="customerKind" slot-scope="text">{{ dictLabel(customerKinds, text) }}</template>
          <template slot="userId" slot-scope="text">{{ userLabel(text) }}</template>
          <template slot="dateTime" slot-scope="text">{{ formatTime(text) }}</template>
          <template slot="protection" slot-scope="text"><span :class="{ 'pool-protected': isFuture(text) }">{{ isFuture(text) ? '保护至 ' : '' }}{{ formatTime(text) }}</span></template>
          <template slot="operation" slot-scope="text, record"><a @click="openView(record)">查看</a><a-divider type="vertical" /><a @click="claim(record)">领取</a><a-divider type="vertical" /><a v-hasPermi="['erp:crm:pool:assign']" @click="openAssign(record)">分配</a></template>
        </a-table>
      </section>

      <a-drawer
        :visible="detailVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        class="erp-doc-drawer"
        @close="detailVisible=false">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header"><div><button class="erp-back-button" type="button" aria-label="返回公海列表" @click="detailVisible=false"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">公海只读详情</span><h3>{{ detail.objectName || '公海档案' }}</h3></div><a-button @click="detailVisible=false">返回列表</a-button></header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag color="orange">公海中</a-tag><span>{{ detail.objectCode }} · {{ detail.objectType === 'lead' ? '线索公海' : '客户公海' }} · 入池于 {{ formatTime(detail.entryTime) }}</span></div>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>档案摘要</h4><p>公海内禁止编辑及新增跟进，手机号由服务端脱敏</p></div></div>
              <div class="pool-detail-grid">
                <label><span>业务编号</span><strong>{{ detail.objectCode || '—' }}</strong></label>
                <label><span>{{ detail.objectType === 'lead' ? '企业名称' : '客户名称' }}</span><strong>{{ detail.objectName || '—' }}</strong></label>
                <label><span>联系人</span><strong>{{ detail.contactName || '—' }}</strong></label>
                <label><span>手机号</span><strong>{{ detail.maskedMobile || '—' }}</strong></label>
                <label><span>所属区域</span><strong>{{ areaLabel(detail.regionId) }}</strong></label>
                <label v-if="detail.objectType === 'lead'"><span>线索来源</span><strong>{{ dictLabel(leadSources, detail.sourceCode) }}</strong></label>
                <label v-if="detail.objectType === 'lead'"><span>线索等级</span><strong>{{ dictLabel(leadLevels, detail.levelCode) }}</strong></label>
                <label v-if="detail.objectType === 'customer'"><span>客户类型</span><strong>{{ dictLabel(customerKinds, detail.customerKind) }}</strong></label>
                <label v-if="detail.objectType === 'customer'"><span>客户等级</span><strong>{{ dictLabel(customerLevels, detail.levelCode) }}</strong></label>
                <label><span>原负责人</span><strong>{{ userLabel(detail.originalOwnerId) }}</strong></label>
                <label><span>最近跟进时间</span><strong>{{ formatTime(detail.lastFollowUpTime) }}</strong></label>
                <label><span>历史领取次数</span><strong>{{ detail.claimCount || 0 }} 次</strong></label>
              </div>
            </section>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">02</span><div><h4>入池记录</h4><p>入池、领取与分配均保留独立事件和操作审计</p></div></div>
              <div class="pool-detail-grid">
                <label><span>入池原因</span><strong>{{ dictLabel(reasons, detail.entryReason) }}</strong></label>
                <label><span>入池时间</span><strong>{{ formatTime(detail.entryTime) }}</strong></label>
                <label><span>保护期截止</span><strong>{{ formatTime(detail.protectionEndTime) }}</strong></label>
                <label class="wide"><span>备注</span><strong>{{ detail.remark || '—' }}</strong></label>
              </div>
            </section>
          </div>
          <footer class="erp-drawer-footer"><div><a-icon type="info-circle" /> 领取或分配后，完整手机号与业务字段按原档案权限恢复展示。</div><div><a-button @click="detailVisible=false">返回列表</a-button><a-button type="primary" @click="claim(detail)">领取{{ detail.objectType === 'lead' ? '线索' : '客户' }}</a-button></div></footer>
        </div>
      </a-drawer>

      <a-modal
        title="分配公海对象"
        :visible="assignVisible"
        :confirm-loading="assigning"
        ok-text="确认分配"
        @ok="submitAssign"
        @cancel="assignVisible=false">
        <a-alert type="info" show-icon message="只能分配给同一经营主体的启用用户" description="主管分配不占用接收人的主动领取额度，但仍会保留完整操作记录。" class="pool-modal-alert" />
        <a-form layout="vertical"><a-form-item label="接收销售"><a-select v-model="assignForm.ownerUserId" show-search option-filter-prop="children" placeholder="请选择接收销售" :loading="userLoading"><a-select-option v-for="item in subjectUsers" :key="item.id" :value="item.id">{{ userName(item) }}（{{ item.dept && item.dept.deptName ? item.dept.deptName : '未配置部门' }}）</a-select-option></a-select></a-form-item><a-form-item label="分配备注"><a-textarea v-model.trim="assignForm.remark" :rows="3" maxlength="500" placeholder="选填" /></a-form-item></a-form>
      </a-modal>

      <a-modal title="批量领取结果" :visible="batchResultVisible" :footer="null" :width="640" @cancel="batchResultVisible=false">
        <a-alert :type="batchResult.failureCount ? 'warning' : 'success'" show-icon :message="`共处理 ${batchResult.totalCount || 0} 条，成功 ${batchResult.successCount || 0} 条，失败 ${batchResult.failureCount || 0} 条`" class="pool-modal-alert" />
        <a-table row-key="id" size="small" :pagination="false" :data-source="batchResult.items || []" :columns="batchColumns"><template slot="batchStatus" slot-scope="text"><a-tag :color="text ? 'green' : 'red'">{{ text ? '成功' : '失败' }}</a-tag></template></a-table>
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
import { getDicts } from '@/api/system/dict/data'
import { pageUser } from '@/api/system/user'
import { getAreaTree } from '@/api/system/area'
import { pageCrmPublicPool, exportCrmPublicPool, getCrmPublicPool, claimCrmPublicPool, assignCrmPublicPool, batchClaimCrmPublicPool, getCrmPoolConfig } from '@/api/erp/crm'

export default {
  name: 'ErpCrmPublicPool',
  data () {
    return {
      activeTab: 'lead',
      query: this.defaultQuery(),
      rows: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      exporting: false,
      selectedRowKeys: [],
      reasons: [],
      leadLevels: [],
      leadSources: [],
      customerKinds: [],
      customerLevels: [],
      userOptions: [],
      userLoading: false,
      areaTree: [],
      areaMap: {},
      poolConfig: { protectionDays: 7, reclaimCooldownDays: 30, claimLimitDays: 7, claimLimitCount: 20 },
      areaReplaceFields: { children: 'children', title: 'areaName', key: 'areaId', value: 'areaId' },
      detailVisible: false,
      detail: {},
      assignVisible: false,
      assigning: false,
      assignForm: {},
      batchResultVisible: false,
      batchResult: {},
      batchColumns: [
        { title: '公海记录ID', dataIndex: 'id', width: 190 },
        { title: '结果', dataIndex: 'success', width: 90, scopedSlots: { customRender: 'batchStatus' } },
        { title: '说明', dataIndex: 'message', ellipsis: true }
      ],
      viewportWidth: window.innerWidth
    }
  },
  computed: {
    currentSubjectId () { const value = this.$store.state.user.info && this.$store.state.user.info.operatingSubjectId; return value == null ? 0 : Number(value) },
    subjectUsers () { return this.userOptions.filter(item => Number(item.operatingSubjectId == null ? 0 : item.operatingSubjectId) === Number(this.currentSubjectId)) },
    drawerWidth () { return this.viewportWidth < 900 ? '100%' : '76%' },
    pagination () { return { current: this.pageNum, pageSize: this.pageSize, total: this.total, showTotal: total => `共 ${total} 条`, showSizeChanger: true } },
    rowSelection () { return { selectedRowKeys: this.selectedRowKeys, onChange: this.changeSelection } },
    columns () {
      const common = [
        { title: this.activeTab === 'lead' ? '线索编号' : '客户编码', dataIndex: 'objectCode', width: 205, fixed: 'left', scopedSlots: { customRender: 'objectCode' } },
        { title: this.activeTab === 'lead' ? '企业名称' : '客户名称', dataIndex: 'objectName', width: 190, ellipsis: true },
        { title: '联系人', dataIndex: 'contactName', width: 110 },
        { title: '手机号', dataIndex: 'maskedMobile', width: 135 },
        { title: '所属区域', dataIndex: 'regionId', width: 160, scopedSlots: { customRender: 'regionId' } }
      ]
      const business = this.activeTab === 'lead'
        ? [{ title: '线索来源', dataIndex: 'sourceCode', width: 110, scopedSlots: { customRender: 'sourceCode' } }, { title: '线索等级', dataIndex: 'levelCode', width: 100, scopedSlots: { customRender: 'levelCode' } }]
        : [{ title: '客户类型', dataIndex: 'customerKind', width: 110, scopedSlots: { customRender: 'customerKind' } }, { title: '客户等级', dataIndex: 'levelCode', width: 100, scopedSlots: { customRender: 'levelCode' } }]
      return common.concat(business, [
        { title: '入池原因', dataIndex: 'entryReason', width: 120, scopedSlots: { customRender: 'entryReason' } },
        { title: '入池时间', dataIndex: 'entryTime', width: 170, scopedSlots: { customRender: 'dateTime' } },
        { title: '原负责人', dataIndex: 'originalOwnerId', width: 120, scopedSlots: { customRender: 'userId' } },
        { title: '保护期', dataIndex: 'protectionEndTime', width: 190, scopedSlots: { customRender: 'protection' } },
        { title: '领取次数', dataIndex: 'claimCount', width: 95, align: 'right' },
        { title: '操作', key: 'operation', width: 175, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ])
    }
  },
  created () {
    Promise.all([this.loadDictionaries(), this.loadUsers(), this.loadAreas(), this.loadPoolConfig()]).finally(this.loadRows)
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy () { window.removeEventListener('resize', this.updateViewport) },
  methods: {
    defaultQuery () { return { keyword: '', entryReason: undefined, regionId: undefined, levelCode: undefined, customerKind: undefined } },
    updateViewport () { this.viewportWidth = window.innerWidth },
    async loadDictionaries () {
      const [reasons, leadLevels, leadSources, customerKinds, customerLevels] = await Promise.all([getDicts('erp_crm_pool_reason'), getDicts('erp_crm_lead_level'), getDicts('erp_crm_lead_source'), getDicts('erp_customer_kind'), getDicts('erp_customer_level')])
      this.reasons = reasons.data || []
      this.leadLevels = leadLevels.data || []
      this.leadSources = leadSources.data || []
      this.customerKinds = customerKinds.data || []
      this.customerLevels = customerLevels.data || []
    },
    loadUsers () { this.userLoading = true; return pageUser({ pageNum: 1, pageSize: 500, status: 1 }).then(res => { this.userOptions = (res.data && res.data.records) || [] }).finally(() => { this.userLoading = false }) },
    loadAreas () { return getAreaTree().then(res => { this.areaTree = res.data || []; const visit = items => (items || []).forEach(item => { this.$set(this.areaMap, String(item.areaId), item.fullName || item.areaName); visit(item.children) }); visit(this.areaTree) }).catch(() => { this.areaTree = [] }) },
    loadPoolConfig () { return getCrmPoolConfig().then(res => { this.poolConfig = { ...this.poolConfig, ...(res.data || {}) } }).catch(() => {}) },
    loadRows () { this.loading = true; pageCrmPublicPool({ ...this.query, objectType: this.activeTab, pageNum: this.pageNum, pageSize: this.pageSize }).then(res => { this.rows = (res.data && res.data.records) || []; this.total = Number((res.data && res.data.total) || 0) }).finally(() => { this.loading = false }) },
    search () { this.pageNum = 1; this.selectedRowKeys = []; this.loadRows() },
    resetQuery () { this.query = this.defaultQuery(); this.search() },
    changeTab () { this.pageNum = 1; this.selectedRowKeys = []; this.query.levelCode = undefined; this.query.customerKind = undefined; this.loadRows() },
    changePage (pagination) { this.pageNum = pagination.current; this.pageSize = pagination.pageSize; this.loadRows() },
    changeSelection (keys) { this.selectedRowKeys = keys },
    openView (record) {
      getCrmPublicPool(record.id).then(res => {
        // 原负责人是本次入池事件的快照字段，详情不应被当前客户归属或前负责人反向覆盖。
        this.detail = Object.assign({}, record, res.data || {}, { originalOwnerId: record.originalOwnerId })
        this.detailVisible = true
      })
    },
    claim (record) {
      this.$confirm({
        title: `领取${record.objectType === 'lead' ? '线索' : '客户'}？`,
        content: '系统将校验重领冷却期和当前账号领取额度。领取成功后恢复到本人名下。',
        okText: '确认领取',
        onOk: () => claimCrmPublicPool(record.id)
          .then(() => { this.$message.success('领取成功'); this.detailVisible = false; this.loadRows() })
          .catch(error => {
            const message = error && error.message ? error.message : ''
            const stale = message.includes('公海记录不存在或已被领取/分配') || message.includes('已不在公海')
            if (!stale) return Promise.reject(error)
            this.detailVisible = false
            this.selectedRowKeys = []
            return this.loadRows()
          })
      })
    },
    openAssign (record) { this.assignForm = { id: record.id, ownerUserId: undefined, remark: '' }; this.assignVisible = true },
    submitAssign () { if (!this.assignForm.ownerUserId) return this.$message.warning('请选择接收销售'); this.assigning = true; assignCrmPublicPool(this.assignForm).then(() => { this.$message.success('分配成功'); this.assignVisible = false; this.loadRows() }).finally(() => { this.assigning = false }) },
    batchClaim () { this.$confirm({ title: `批量领取 ${this.selectedRowKeys.length} 条数据？`, content: '每条数据独立校验并提交，不会因其中一条失败而回滚其他成功记录。', okText: '开始领取', onOk: () => batchClaimCrmPublicPool(this.selectedRowKeys).then(res => { this.batchResult = res.data || {}; this.batchResultVisible = true; this.selectedRowKeys = []; this.loadRows() }) }) },
    exportCurrent () {
      this.exporting = true
      exportCrmPublicPool({ ...this.query, objectType: this.activeTab }).then(res => {
        const records = res.data || []
        if (!records.length) return this.$message.warning('当前查询无可导出数据')
        const header = ['业务编号', this.activeTab === 'lead' ? '企业名称' : '客户名称', '联系人', '脱敏手机号', '所属区域', '入池原因', '入池时间', '原负责人', '保护期截止', '领取次数']
        const lines = records.map(item => [item.objectCode, item.objectName, item.contactName, item.maskedMobile, this.areaLabel(item.regionId), this.dictLabel(this.reasons, item.entryReason), this.formatTime(item.entryTime), this.userLabel(item.originalOwnerId), this.formatTime(item.protectionEndTime), item.claimCount || 0])
        const csv = [header].concat(lines).map(row => row.map(value => `"${String(value == null ? '' : value).replace(/"/g, '""')}"`).join(',')).join('\n')
        const url = URL.createObjectURL(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' }))
        const link = document.createElement('a')
        link.href = url
        link.download = `${this.activeTab === 'lead' ? '线索公海' : '客户公海'}_${Date.now()}.csv`
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.setTimeout(() => URL.revokeObjectURL(url), 1000)
      }).finally(() => { this.exporting = false })
    },
    userName (user) { return user ? `${user.nickName || user.userName}（${user.userName}）` : '—' },
    userLabel (id) { if (id == null) return '—'; const user = this.userOptions.find(item => String(item.id) === String(id)); return user ? (user.nickName || user.userName) : `用户 #${id}` },
    subjectLabel (id) { return id == null ? '—' : (Number(id) === 0 ? '默认经营主体' : `经营主体 #${id}`) },
    areaLabel (id) { return id == null ? '—' : (this.areaMap[String(id)] || `区域 #${id}`) },
    dictLabel (items, value) { const found = (items || []).find(item => item.dictValue === value); return found ? found.dictLabel : (value || '—') },
    formatTime (value) { return value ? String(value).replace('T', ' ').slice(0, 16) : '—' },
    isFuture (value) { return value ? new Date(value).getTime() > Date.now() : false }
  }
}
</script>

<style scoped>
.pool-tabs{padding:0 20px}.pool-view-toolbar{display:flex;min-height:46px;align-items:center;gap:10px;padding:0 20px 14px}.pool-selection-hint,.pool-rule-hint{color:#66758a;font-size:12px}.pool-rule-hint{margin-left:2px}.pool-rule-hint .anticon{margin-right:5px;color:#2878d0}.pool-protected{color:#ad6800}.pool-modal-alert{margin-bottom:16px}.pool-detail-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:1px;border:1px solid #e4eaf1;background:#e4eaf1}.pool-detail-grid label{display:flex;min-height:78px;flex-direction:column;gap:7px;padding:14px;background:#fbfcfe}.pool-detail-grid label.wide{grid-column:1/-1}.pool-detail-grid span{color:#7a8798;font-size:12px}.pool-detail-grid strong{color:#263549;font-size:14px;font-weight:500;word-break:break-word}@media(max-width:1100px){.pool-detail-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:700px){.pool-view-toolbar{align-items:flex-start;flex-direction:column}.pool-detail-grid{grid-template-columns:1fr}}
</style>
